module.exports = __webpack_public_path__ + "img/courage.20756922.png";